import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { SuggestedAmounts } from './SuggestedAmounts.js';
import { TeacherGiftCardWidget } from '../common/TeacherGiftCardWidget.js';
import { GiveWidget } from '../common/GiveWidget.js';
import { makeDonationSticky } from '../projectpage/giveWidgetOverrides.js';


/* global dcAnalytics */

/**
 * Note that getDonateOptions() assumes that, when in mobile view, the desktop version of the form will be moved in place and submitted by JQuery.
 * This caused problems for React, so the fully funded project page is refactored so that the mobile view has its own form.
 * getDonateOptions() continues to support fully funded widgets for giving page, teacher page, and school page.
 */

export const FullyFundedProjectCallToAction = createReactClass({

    propTypes: {

        teacherId: PropTypes.number.isRequired,
        teacherScreenName: PropTypes.string.isRequired,
        teacherPossessivePronoun: PropTypes.string.isRequired,

        schoolGradeType: PropTypes.object.isRequired,
        schoolStateObj: PropTypes.object.isRequired,

        numActiveProjects: PropTypes.number.isRequired,
        activeProject: PropTypes.object,

        isTeacherReferred: PropTypes.bool.isRequired,
        isMobileView: PropTypes.bool.isRequired,

    },

    getDefaultProps: function () {
        return {
            isTeacherReferred: false,
        };
    },

    getInitialState: function () {
        return {
            showSuggestedAmounts: false,
        };
    },

    componentDidMount: function () {
        makeDonationSticky();
    },

    openSuggestedAmounts: function () {
        this.setState({
            showSuggestedAmounts: true,
        });
        $('.mobile-donation-box').addClass('showSuggestedAmounts');
        this.handleHeightChange();
    },

    closeSuggestedAmounts: function () {
        this.setState({
            showSuggestedAmounts: false,
        });
        $('.mobile-donation-box').removeClass('showSuggestedAmounts');
        $('.mobile-donation-box').css({ height: '' });
    },

    handleHeightChange: function () {
        $('.mobile-donation-box').css({ height: $('.mobile-donation-box')[0].scrollHeight + 'px' });
    },

    getTeacherGiftCard: function () {
        var props = this.props;
        return (
            <div className="donation-box js-sticky-box funded js-project-cta-teacher-giftcard">
                <div id="inspire-form-holder-desktop" className="container clearfix">
                    <p><strong>Keep the momentum going!</strong> Make a donation to <span>{props.teacherScreenName}</span> for {props.teacherPossessivePronoun} next project!</p>
                    <TeacherGiftCardWidget
                        teacherId={props.teacherId}
                        teacherScreenName={props.teacherScreenName} />
                </div>
            </div>
        );
    },

    getTeacherGiftCardMobile: function () {
        var props = this.props;
        return (

            <div id="inspire-form-holder-mobile" className="container clearfix js-project-cta-teacher-giftcard">
                <p className="give-to-teacher-text"><strong>Keep the momentum going!</strong> Make a donation to <span>{props.teacherScreenName}</span> for {props.teacherPossessivePronoun} next project!</p>
                <SuggestedAmounts
                    showSuggestedAmounts={this.state.showSuggestedAmounts}
                    handleShowAnotherAmount={this.handleHeightChange}
                    handleCloseSuggestedAmounts={this.closeSuggestedAmounts}
                >
                    <TeacherGiftCardWidget
                        teacherId={props.teacherId}
                        teacherScreenName={props.teacherScreenName}
                        formId={'inspireFormMobile'}
                    />

                </SuggestedAmounts>
                <div id="donateBar" className="funded">
                    <div id="donateButton" className="button-primary" onClick={this.openSuggestedAmounts}>Help {props.teacherScreenName}</div>
                </div>
            </div>
        );
    },

    getActiveProject: function () {
        var props = this.props;
        if (props.numActiveProjects > 0) {
            return (
                <div className="donation-box js-sticky-box funded project-cta-teacher-project js-project-cta-teacher-project">
                    <div id="inspire-form-holder-desktop" className="container clearfix">
                        <p><strong>{props.teacherScreenName} has another project!</strong> Donate to <a href={baseURL + props.activeProject.proposalURL} dangerouslySetInnerHTML={{ __html: props.activeProject.proposalTitle }}></a> to help {props.teacherPossessivePronoun} classroom.</p>
                        <GiveWidget
                            showGiveWidget={true}
                            projectId={String(this.props.activeProject.proposalId)}
                            project={this.props.activeProject}
                            submitTakesUserDirectlyToCart={true}
                            showPrimaryGiveButton={true}
                            showMatchCallout={true}
                        />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    },

    getActiveProjectMobile: function () {
        var props = this.props;
        if (props.numActiveProjects > 0) {
            return (
                <div id="inspire-form-holder-mobile" className="container clearfix project-cta-teacher-project js-project-cta-teacher-project">
                    <p className="give-to-teacher-text"><strong>{props.teacherScreenName} has another project!</strong> Donate to <a href={baseURL + props.activeProject.proposalURL} dangerouslySetInnerHTML={{ __html: props.activeProject.proposalTitle }}></a> to help {props.teacherPossessivePronoun} classroom.</p>

                    <SuggestedAmounts
                        showSuggestedAmounts={this.state.showSuggestedAmounts}
                        handleShowAnotherAmount={this.handleHeightChange}
                        handleCloseSuggestedAmounts={this.closeSuggestedAmounts}
                        completionAmount={parseFloat(this.props.activeProject.completingDonationAmount)}
                    >
                        <GiveWidget
                            showGiveWidget={true}
                            projectId={String(this.props.activeProject.proposalId)}
                            project={this.props.activeProject}
                            submitTakesUserDirectlyToCart={true}
                            showPrimaryGiveButton={true}
                            giveWidgetFormId={'simpleWidgetFormMobile'}
                            showMatchCallout={true}
                        />

                    </SuggestedAmounts>

                    <div id="donateBar" className="funded">
                        <div id="donateButton" className="button-primary" onClick={this.openSuggestedAmounts}>Help {props.teacherScreenName}</div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    },

    trackCTAChoice: function (ctaChoice) {
        if (dcAnalytics) {
            dcAnalytics.track('project cta ' + ctaChoice);
        }
    },

    render: function () {
        if (this.props.numActiveProjects > 0) {
            this.trackCTAChoice('teacher other project');
            if (this.props.isMobileView) {
                return this.getActiveProjectMobile();
            }
            return this.getActiveProject();
        } else {
            this.trackCTAChoice('teacher gift card');
            if (this.props.isMobileView) {
                return this.getTeacherGiftCardMobile();
            }
            return this.getTeacherGiftCard();
        }
    },
});
